import { render, staticRenderFns } from "./CbsJsonValue.vue?vue&type=template&id=80fadb26&scoped=true"
import script from "./CbsJsonValue.vue?vue&type=script&lang=js"
export * from "./CbsJsonValue.vue?vue&type=script&lang=js"
import style0 from "./CbsJsonValue.vue?vue&type=style&index=0&id=80fadb26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fadb26",
  null
  
)

export default component.exports